/* eslint-disable react-hooks/exhaustive-deps */
import React, {Fragment} from 'react';
import {makeStyles} from '@material-ui/core/styles';
// noinspection ES6CheckImport
import {connectCurrentRefinements} from 'react-instantsearch-dom';
import { Button } from '@material-ui/core';

const useStylesClearFilterBottom = makeStyles((t) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: 0,
    margin: 0,
  },
  item: {
    display: 'flex',
    padding: t.spacing(1),
    justifyContent: 'center',
    alignItems: 'center',
    '&:not(:last-child)': {
      marginRight: 5,
    },
  },
}));

function ClearFilterBottom({items, refine}) {
  const classes = useStylesClearFilterBottom();

  if (!items.length) {
    return <div />;
  }

  return (
    <Fragment>
      <Button variant='outlined' color='secondary' onClick={() => refine(items)} disabled={!items.length}>
        Borrar filtros
      </Button>
      
      <div className={classes.root}>
        {items.map((item, i) => (
          <div key={i} className={classes.item}>
            {/^categories\.[\S]*/gi.test(item.attribute) &&
              `Categorías: ${(Array.isArray(item.currentRefinement)
                ? item.currentRefinement
                : [item.currentRefinement]
              ).join(', ')}`}
            {/^brand\.[\S]*/gi.test(item.attribute) &&
              `Marcas: ${(Array.isArray(item.currentRefinement)
                ? item.currentRefinement
                : [item.currentRefinement]
              ).join(', ')}`}
            {/^discount_percentage*/gi.test(item.attribute) && (
              `Descuento: ${(Array.isArray(item.currentRefinement)
                ? item.currentRefinement
                : [item.currentRefinement]
              ).join(', ')}`
            )}
          </div>
        ))}
      </div>
    </Fragment>
  );
}

export default connectCurrentRefinements(ClearFilterBottom);
